import React, { useContext } from 'react';

import { Checkbox, Radio } from '../../Fields';

import { SelectModalItemContext } from './SelectModalItem.state';
import { Context } from './SelectModalItemBase';

interface SelectModalItemCheckerProps<S, D> {
  readonly asRadio?: boolean;
  readonly selected?: S | ((selected: S) => boolean);
  readonly disabled?: D | ((disabled: D) => boolean);
  readonly className?: string;
}

function SelectModalItemCheckerFactory<S, D, H>(context: React.Context<SelectModalItemContext<S, D, H>>) {
  function SelectModalItemDefaultChecker({
    asRadio,
    selected: _selected,
    disabled: _disabled,
    className,
  }: SelectModalItemCheckerProps<S, D>) {
    const { selected: selectedCtx, disabled: disabledCtx } = useContext(context);
    let selected = !!selectedCtx;
    let disabled = !!disabledCtx;

    if (_selected !== undefined) {
      if (typeof _selected === 'function') {
        selected = (_selected as (selected: S) => boolean)(selectedCtx);
      } else {
        selected = !!_selected;
      }
    }

    if (_disabled !== undefined) {
      if (typeof _disabled === 'function') {
        disabled = (_disabled as (disabled: D) => boolean)(disabledCtx);
      } else {
        disabled = !!_disabled;
      }
    }

    return asRadio ? (
      <Radio readOnly checked={selected} disabled={disabled} className={className} />
    ) : (
      <Checkbox readOnly checked={selected} disabled={disabled} className={className} />
    );
  }

  SelectModalItemDefaultChecker.Factory = SelectModalItemCheckerFactory;

  return SelectModalItemDefaultChecker;
}

const SelectModalItemDefaultChecker = SelectModalItemCheckerFactory(Context);

export { SelectModalItemDefaultChecker };
